import { render, staticRenderFns } from "./ThumbnailGenerator.vue?vue&type=template&id=12ba3f3b&scoped=true"
import script from "./ThumbnailGenerator.vue?vue&type=script&lang=js"
export * from "./ThumbnailGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba3f3b",
  null
  
)

export default component.exports